import { render } from "./order-list.vue?vue&type=template&id=36b1fea8"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"

import "./order-list.vue?vue&type=style&index=0&id=36b1fea8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__